import { Box } from "@mui/material";

function NotFound() {
  return <Box>Page Not Found</Box>;
}

export default NotFound;
